import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Table,
  Button,
  Card,
  CardBody
} from "reactstrap";

import {
  getBatchStudentsApi,
  getAvailableStudentsApi,
  addStudentToBatchApi,
  removeStudentFromBatchApi,
} from "../../api/apiUrlConst";

interface Props {
  batchId: number | null;
  isOpen: boolean;
  toggle: () => void;
}

const BatchStudentsModal: React.FC<Props> = ({
  batchId,
  isOpen,
  toggle,
}) => {
  const [students, setStudents] = useState<any[]>([]);
  const [availableStudents, setAvailableStudents] = useState<any[]>([]);
  // eslint-disable-next-line
  const [historyModal, setHistoryModal] = useState(false);

  const loadStudents = async () => {
    if (!batchId) return;

    try {
      const res = await getBatchStudentsApi(batchId);
      console.log("Batch Students:", res);

      setStudents(res);

      const available = await getAvailableStudentsApi(batchId);
      console.log("Available Students:", available);

      setAvailableStudents(available);
    } catch (err) {
      console.error("Error loading students", err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      loadStudents();
    }// eslint-disable-next-line
  }, [isOpen, batchId]);

  const handleAdd = async (enqFormId: number) => {
    if (!batchId) return;

    try {
      await addStudentToBatchApi(batchId, enqFormId);

      // update UI instantly
      const student = availableStudents.find(s => s.id === enqFormId);

      if (student) {
        setStudents([...students, student]);
        setAvailableStudents(
          availableStudents.filter(s => s.id !== enqFormId)
        );
      }

    } catch (err: any) {
      console.error("Add student error:", err.response?.data);
    }
  };

  const handleRemove = async (id: number) => {
    try {
      await removeStudentFromBatchApi(id);
      loadStudents();
    } catch (err) {
      console.error("Remove student error", err);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>

      {/* Header */}
      <ModalHeader
        toggle={toggle}
        style={{
          background: "linear-gradient(90deg,#374151,#093d92)",
          color: "#fff",
          borderBottom: "none"
        }}
      >
        👨‍🎓 Batch Students Management
      </ModalHeader>

      <ModalBody style={{ background: "#f4f6fb" }}>

        <Row>

          {/* Batch Students */}
          <Col md="6">

            <Card className="border-0 shadow-sm">
              <CardBody>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold mb-0">Batch Students</h6>

                  <span
                    className="badge bg-primary"
                    style={{ fontSize: "12px" }}
                  >
                    {students.length}
                  </span>
                </div>

                <div style={{ maxHeight: "300px", overflowY: "auto" }}>

                  <Table hover className="align-middle">

                    <tbody>
                      {students.length === 0 ? (
                        <tr>
                          <td className="text-center text-muted py-4">
                            No Students
                          </td>
                        </tr>
                      ) : (
                        students.map((s) => (
                          <tr key={s.id}
                            style={{
                              background: "#fff",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                            }}
                          >

                            <td className="fw-semibold">
                              {s.studentName || s.name || s.student?.name}
                            </td>

                            <td className="text-end">
                              <Button
                                size="sm"
                                style={{
                                  background: "#dc3545",
                                  border: "none",
                                  borderRadius: "20px"
                                }}
                                onClick={() => handleRemove(s.id)}
                              >
                                Remove
                              </Button>
                            </td>

                          </tr>
                        ))
                      )}
                    </tbody>

                  </Table>

                </div>

              </CardBody>
            </Card>

          </Col>

          {/* Available Students */}
          <Col md="6">

            <Card className="border-0 shadow-sm">
              <CardBody>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold mb-0">Available Students</h6>

                  <span
                    className="badge bg-success"
                    style={{ fontSize: "12px" }}
                  >
                    {availableStudents.length}
                  </span>
                </div>

                <div style={{ maxHeight: "300px", overflowY: "auto" }}>

                  <Table hover className="align-middle">

                    <tbody>
                      {availableStudents.length === 0 ? (
                        <tr>
                          <td className="text-center text-muted py-4">
                            No Available Students
                          </td>
                        </tr>
                      ) : (
                        availableStudents.map((s) => (
                          <tr
                            key={s.id || s.enqFormId}
                            style={{
                              background: "#fff",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                            }}
                          >

                            <td className="fw-semibold">
                              {s.studentName || s.name}
                            </td>

                            <td className="text-end">

                              <Button
                                size="sm"
                                style={{
                                  background: "#20c997",
                                  border: "none",
                                  borderRadius: "20px"
                                }}
                                onClick={() => handleAdd(s.id || s.enqFormId)}
                              >
                                Add
                              </Button>

                            </td>

                          </tr>
                        ))
                      )}
                    </tbody>

                  </Table>

                </div>

              </CardBody>
            </Card>

          </Col>

        </Row>


      </ModalBody>

    </Modal>

  );
};

export default BatchStudentsModal;